import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, User, Eye, ArrowRight } from 'lucide-react';
import { optimizeCloudinaryUrl, generateSrcSet, getImageSizes } from '../utils/imageOptimization';

const BlogCard = ({ blog }) => {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('tr-TR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <Link 
      to={`/blog/${blog.slug}`}
      className="group block bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
    >
      {/* Thumbnail Image */}
      <div className="relative h-56 overflow-hidden">
        <img 
          src={optimizeCloudinaryUrl(blog.thumbnailImage, { width: 665, quality: 'auto:good' })} 
          srcSet={generateSrcSet(blog.thumbnailImage, [400, 665, 800])}
          sizes={getImageSizes('card')}
          alt={blog.title}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
          loading="lazy"
          width="665"
          height="444"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
        
        {/* View Count Badge */}
        <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full flex items-center gap-1.5 text-sm">
          <Eye className="w-4 h-4 text-pink-600" />
          <span className="font-medium text-gray-700">{blog.viewCount || 0}</span>
        </div>
      </div>

      {/* Content */}
      <div className="p-6">
        {/* Meta Info */}
        <div className="flex items-center gap-4 text-sm text-gray-500 mb-3">
          <div className="flex items-center gap-1.5">
            <Calendar className="w-4 h-4" />
            <span>{formatDate(blog.createdAt)}</span>
          </div>
          <div className="flex items-center gap-1.5">
            <User className="w-4 h-4" />
            <span>{blog.author}</span>
          </div>
        </div>

        {/* Title */}
        <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-pink-600 transition-colors line-clamp-2">
          {blog.title}
        </h3>

        {/* Excerpt */}
        <p className="text-gray-600 mb-4 line-clamp-3">
          {blog.excerpt}
        </p>

        {/* Read More */}
        <div className="flex items-center gap-2 text-pink-600 font-semibold group-hover:gap-3 transition-all">
          <span>Devamını Oku</span>
          <ArrowRight className="w-5 h-5" />
        </div>
      </div>
    </Link>
  );
};

export default BlogCard;
